import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"

import {Destination} from "~/utils/ShelfEntities"

import {Button} from "~/components/"

import {DestinationStocksList} from "~/views/list/DestinationStocksList"
import {withTranslation} from "react-i18next"

class DestinationDetailView extends ComponentWithData {
  getData() {
    return Destination.find(this.props.match.params.destination_id)
  }
  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }
  renderError() {
    return (
      <p>
        {this.props.t("error")} {console.log(this.state.error)}
      </p>
    )
  }
  renderEmpty() {
    return <p>{this.props.t("destinations.notFound")}</p>
  }
  renderWithData() {
    return (
      <React.Fragment>
        <div className="sh-detail-view">
          <div className="header">
            <div className="title">{this.state.data.name}</div>
            <div className="actions">
              <Button
                primary
                to={"/destinations/" + this.state.data.id}
                label={this.props.t("edit")}
              />
            </div>
          </div>
        </div>
        <DestinationStocksList
          id={this.props.match.params.destination_id}
          destination={this.state.data}
        />
      </React.Fragment>
    )
  }
}

export default withTranslation()(DestinationDetailView)



// WEBPACK FOOTER //
// ./src/views/detail/DestinationDetailView.js